import { useAppLocalization } from "../../../modules/localization/components/AppLocalizationProvider"
import { OrderStatus } from "../../../modules/merchant/controlKitchenTypes"
import { Placement, StandardChip } from "./StandardChip"

type OrderStatusBadgeProps = {
    status: OrderStatus | ""
    className?: string
    placement?: Placement
}

export default function OrderStatusBadge({ status, className, placement }: OrderStatusBadgeProps) {
    const { l10n } = useAppLocalization()

    switch (status) {
        case "CANCELLED":
            return (
                <StandardChip
                    placement={placement}
                    label={l10n.getString("production-order-status-cancelled")}
                    variant="red"
                />
            )

        case "CONFIRMED":
            return (
                <StandardChip
                    placement={placement}
                    label={l10n.getString("production-order-status-confirmed")}
                    variant="info"
                />
            )

        case "READY":
            return (
                <StandardChip
                    placement={placement}
                    label={l10n.getString("production-order-status-ready")}
                    variant="success"
                />
            )

        case "RECEIVED":
            return (
                <StandardChip
                    placement={placement}
                    label={l10n.getString("production-order-status-received")}
                    variant="grey"
                />
            )

        default:
            return <></>
    }
}
